module.exports = __webpack_public_path__ + "img/thumb_aula34.916304c3.jpg";